import type { ReactNode } from "react";
import { Card } from "./Card";

interface Props {
  title: string;
  body?: string;
  cta?: ReactNode;
  icon?: ReactNode;
}

export function EmptyState({ title, body, cta, icon }: Props) {
  return (
    <Card>
      <div className="flex flex-col items-center text-center py-8 px-4 gap-3">
        {icon && (
          <div className="w-12 h-12 rounded-full bg-fh-sage text-fh-green-dark flex items-center justify-center mb-1">
            {icon}
          </div>
        )}
        <h3 className="font-serif text-[18px] text-fh-ink m-0">{title}</h3>
        {body && (
          <p className="text-[14px] text-fh-gray max-w-md leading-relaxed m-0">{body}</p>
        )}
        {cta && <div className="mt-2">{cta}</div>}
      </div>
    </Card>
  );
}
